/**
 * MagZoom's cancellation and refund terms, in one place because this brand publishes them
 * in two: `/refund` is these words and nothing else, and they are the FAQ's
 * fourth answer.
 *
 * The words were `includes/modules/legal/returns.html`, written out here rather than
 * included as a document, which is how DiscountMags' refund page already works. That
 * module rendered only in the checkout lightbox, and the checkout agreement links to
 * `/refund` instead now, so it is gone and these words live here alone.
 *
 * Not a card and not a heading: it is the terms alone, so either caller can frame them the
 * way its own page frames things.
 */
export default function RefundTerms() {
  return (
    <p>
      Our #1 goal is customer satisfaction. If you are unhappy with your subscription for whatever
      reason within 6 months, we will offer a pro-rated refund for any undelivered issues. After 6
      months of your order date, there will be no refunds.
    </p>
  );
}
